import { useAuth } from '@/features/auth/useAuth'
import { useIsCatalogCourse } from '@/hooks/useIsCatalogCourse'
import { useQueryCertificateRecordsQuery } from '@/store/api/certificateRecordApi'

type Params = {
  objectiveId: string
}

export const useAssignedCertificateRecords = ({ objectiveId }: Params) => {
  const { user } = useAuth()

  const loadOptions = {
    filter: `[["objectiveId", "=", "${objectiveId}"], "and", ["userId", "=", "${user?.id}"]]`,
    sort: `[{"selector": "created", "desc": true}]`,
  }

  const { data: certificateRecordData, isLoading: isCertificateRecordLoading } = useQueryCertificateRecordsQuery(
    loadOptions,
    { refetchOnMountOrArgChange: true, skip: useIsCatalogCourse() },
  )

  return {
    certificateRecordData,
    isCertificateRecordLoading,
  }
}
